import { ReactElement } from 'react';

const stringToColour = (str: string) => {
  let hash = 0;
  str.split('').forEach((char) => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash);
  });
  let colour = '#';
  const getDarkChannel = (value: number): string => {
    const darkValue = 125 + value % 131;

    return darkValue.toString(16).padStart(2, '0');
  };

  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;

    colour += getDarkChannel(value);
  }

  return colour;
};

const SIZE_MAP = {
  small: 'size-7 text-sm',
  medium: 'size-9 text-base',
  large: 'size-12 text-lg',
} as const;

interface Props {
  name: string | null | undefined;
  fallback?: string;
  size?: keyof typeof SIZE_MAP;
}

export const Avatar = ({
  name,
  fallback = '?',
  size = 'medium',
}: Props): ReactElement => {
  const source = name?.trim() ?? fallback;
  const letter = source.slice(0, 1).toUpperCase();
  const colour = stringToColour(source);

  return (
    <div
      className={`${SIZE_MAP[size]} rounded-full flex items-center justify-center border shrink-0`}
      style={{
        backgroundColor: `${colour}26`, // 15%
        borderColor: colour
      }}
    >
      <span className="font-semibold leading-none block" style={{ color: colour }}>
        {letter}
      </span>
    </div>
  );
};
